// react
/* eslint-disable */
/* eslint-disable prefer-template */
/* eslint-disable max-len */
// react
import React, { useState } from "react";
import axios from "axios";
import { MyApiUrl, ViewImg } from "../services/service";
// third-party
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// data stubs
import dataAddresses from "../../data/accountAddresses";
import theme from "../../data/theme";
import "./AddressCard.css";

export default function AccountPageAddresses() {
    const UserID = localStorage.getItem("UserID");
    const UserEmail = localStorage.getItem("UserEmail");
    const [CardData, setCardData] = useState([]);

    const GetAddress = () => {
        axios.get(MyApiUrl + "UserAddress/" + UserID + "").then((response) => {
            console.log(response);
            if (response.data.length > 0) {
                setCardData(response.data);
            } else {
                setCardData([]);
            }
        });
    };

    const SetDefaultAddress = (AddressPkid) => {
        axios.get(MyApiUrl + "UpdateDefaultAddress/" + AddressPkid + "/" + UserID + "").then((response) => {
            if (response.data == "true" || response.data == true) {
                toast.success("Address set to Default!", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "dark",
                });
                GetAddress();
            } else {
                toast.error("Failed to set as Default!", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "dark",
                });
            }
        });
    };
    const DeleteAddress = (val) => {
        axios.delete(MyApiUrl + "UserAddress/" + val + "").then((response) => {
            if (response.data == true) {
                toast.success("Deleted Succesfully!", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "dark",
                });
                GetAddress();
            } else {
                toast.error("Failed to Delete!", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "dark",
                });
            }
        });
    };
    React.useEffect(() => {
        GetAddress();
    }, []);
    const addresses = CardData.map((val, key) => (
        <React.Fragment key={val.user_address_pkid}>
            <div className="addr-card">
                <div className="addr-top">
                    <div>
                        <h4 className="addr-name">{val.user_address_name}</h4>
                        <span className="addr-type">{val.user_address_type}</span>
                    </div>

                    {(val.user_address_default === 1 || val.user_address_default === "1") && (
                        <span className="addr-default">Default</span>
                    )}
                </div>

                <div className="addr-body">
                    <p className="addr-text">
                        {val.user_address_house_no}, {val.user_address_street}
                        <br />
                        {val.area_name}, {val.city_name}, {val.state_name}
                        <br />
                        {val.country_name} - {val.user_address_zipcode}
                    </p>

                    <div className="addr-meta">
                        <span>📞 {val.user_address_phone}</span>
                        <span>✉️ {UserEmail}</span>
                    </div>
                </div>

                <div className="addr-actions">
                    {!val.user_address_default && (
                        <button
                            className="btn-outline primary"
                            onClick={() => SetDefaultAddress(val.user_address_pkid)}
                        >
                            Set Default
                        </button>
                    )}

                    <Link
                        to={{
                            pathname: "/account/EditAddress",
                            state: { pkid: val.user_address_pkid },
                        }}
                        className="btn-outline warning"
                    >
                        Edit
                    </Link>

                    {!(val.address_linked_status == 1 || val.address_linked_status == "1") && (
                        <button className="btn-outline danger" onClick={() => DeleteAddress(val.user_address_pkid)}>
                            Remove
                        </button>
                    )}
                </div>
            </div>

            <div className="addresses-list__divider" />
        </React.Fragment>
    ));

    return (
        <React.Fragment>
            <div className="addresses-list">
                <Helmet>
                    <title>{`Address List — ${theme.name}`}</title>
                </Helmet>

                <Link to="/account/AddAddress" className="addresses-list__item addresses-list__item--new">
                    <div className="addresses-list__plus" />
                    <div className="btn btn-secondary btn-sm">Add New</div>
                </Link>
                <div className="addresses-list__divider" />
                {addresses}
            </div>
            <div
                style={{
                    marginTop: 15,
                    fontSize: 14,
                    textAlign: "center",
                }}
            >
                <p>
                    <span style={{ fontWeight: "bold" }}>Note: </span>If Delete Option is not Available, then the
                    address is linked to your Placed Orders
                </p>
            </div>
        </React.Fragment>
    );
}
